import type { GuidedPort } from '../../core/guided'
import { restrictionLabel } from './PortAccess'

/**
 * "What you are renting" rows for restricted ports: each port, its list, and
 * what the restriction asks of the host. Nothing renders for an unrestricted
 * rental, so the review reads exactly as it did before allowlists existed.
 */
export function PortAccessReview({ ports, hostLine }: { ports: readonly GuidedPort[]; hostLine: string }) {
  const restricted = ports.filter((port) => (port.allowFrom?.length ?? 0) > 0)
  if (restricted.length === 0) return null
  return <>
    {restricted.map((port) => <div key={`${port.container}-${port.protocol}`} className="review-access">
      <dt>Port {port.container}{port.protocol === 'udp' ? ' (UDP)' : ''}</dt>
      <dd>
        <span>{restrictionLabel(port.allowFrom!.length)}</span>
        <ul className="review-access-list">{port.allowFrom!.map((entry) => <li key={entry}><code>{entry}</code></li>)}</ul>
      </dd>
    </div>)}
    <div><dt>IP restrictions</dt><dd>{hostLine}</dd></div>
  </>
}

/** Competitive: placement admits only enforcing hosts, so every offer qualifies. */
export const COMPETITIVE_ALLOWLIST_LINE = 'Only hosts that enforce IP restrictions can make an offer.'
/** Direct: the chosen host was checked for the capability. */
export const DIRECT_ALLOWLIST_LINE = 'This provider enforces IP restrictions.'
